import axiosInstance from './axiosInstance';

// // 统一请求头处理（升级版）
// const getStoryHeaders = () => {
//   let sessionId = null;
  
//   try {
//     // 优先从 sessionStorage 获取
//     sessionId = sessionStorage.getItem("story_session_id");
//   } catch (error) {
//     // 处理隐私模式等异常情况
//     console.debug("Session storage access failed, using fallback");
//   }
//   // 降级方案检测
//   if (!sessionId && window.__storySessionId) {
//     sessionId = window.__storySessionId;
//   }
//   return {
//     "X-Session-ID": sessionId || "invalid_session",
//     "Content-Type": "application/json",
//     "X-Client-Version": __APP_VERSION__ // 推荐添加版本跟踪
//   };
// };
// 统一请求头处理（增强隔离版）
const getStoryHeaders = (() => {
  // 使用闭包隔离内存存储
  let memorySessionId = null;
  let memoryFallback = false;

  return () => {
    let sessionId = null;
    
    try {
      // 严格检测sessionStorage可用性
      if (typeof sessionStorage !== 'undefined') {
        sessionId = sessionStorage.getItem("story_session_id");
        // 如果不存在则创建新会话
        if (!sessionId) {
          sessionId = generateSessionId();
          sessionStorage.setItem("story_session_id", sessionId);
        }
      }
    } catch (error) {
      // 隐私模式等异常处理
      if (!memoryFallback) {
        memorySessionId = generateSessionId();
        memoryFallback = true;
      }
      sessionId = memorySessionId;
      console.debug("Session storage access failed, using memory fallback");
    }

    // 最终回退方案（避免null）
    if (!sessionId) {
      sessionId = "invalid_session_" + Math.random().toString(36).substr(2, 9);
    }

    return {
      "X-Session-ID": sessionId,
      "Content-Type": "application/json",
      "X-Client-Version": __APP_VERSION__,
      "X-Session-Source": memoryFallback ? "memory" : "sessionStorage"
    };
  };
})();

// 强化的会话ID生成函数
function generateSessionId() {
  return 'ts-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9) + 
         '-' + (performance?.now?.().toString(36).replace('.','') || '');
}

export const generateStoryStart = async (data) => {
  console.log('Generating story start with data:', data); // 添加日志
  const response = await axiosInstance.post('/generate-story-start', data, {
    headers: getStoryHeaders()
  });
  console.log('Story start response:', response.data); // 添加日志
  return response.data;
};

export const generateStoryContinuation = async (data) => {
  console.log('Generating story continuation with data:', data); // 添加日志
  const response = await axiosInstance.post('/generate-story-continuation', data, {
    headers: getStoryHeaders()
  });
  console.log('Story continuation response:', response); // 添加日志
  return response.data;
};

export const generateStoryEnd = async (data) => {
  const response = await axiosInstance.post('/generate-story-end', data, {
    headers: getStoryHeaders()
  });
  return response.data;
};